<template>
  <view>
    <view class="nav-header" :style="{ height: allHeight + 'px', background: navBackgroundColor }">
      <view class="status-bar" :style="{ height: statusBarHeight + 'px' }"></view>
      <view class="top-content">
        <view v-if="isBack" class="goBack" @click="goBack(backUrl)" hover-class="back-hover">
          <u-icon name="arrow-left" :color="backColor"></u-icon>
        </view>
        <view class="title" :style="{ color: color }">{{ title }}</view>
      </view>
    </view>
    <view v-if="isHeight" class="margin-box" :style="{ height: allHeight + 'px' }"></view>
  </view>
</template>

<script>
export default {
  name: 'NavHeader',
  props: {
    title: {
      type: String,
      default: 'XXX',
    },
    navBackgroundColor: {
      //背景色
      type: String,
      default: 'rgba(255,255,255, 0)',
    },
    color: {
      //字体颜色
      type: String,
      default: '#000;',
    },
    isBack: {
      //是否有返回箭头
      type: Boolean,
      default: false,
    },
    backColor: {
      //回退箭头颜色
      type: String,
      default: 'white',
    },
    isHeight: {
      //头部撑开高度
      type: Boolean,
      default: true,
    },
    isNavBack: {
      //固定返回前面的页面
      type: Boolean,
      default: true,
    },
    backUrl: {
      //返回到那个页面
      type: String,
      default: 'index',
    },
    backNum: {
      //返回几个页面
      type: Number,
      default: 1,
    },
    intercept: {
      // 是否拦截返回
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      statusBarHeight: 0,
      titleBarHeight: 0,
      allHeight: 0,
    };
  },
  methods: {
    goBack(url) {
      if (this.intercept === true) {
        this.$emit('customGoBack');
        return;
      }
      if (this.isNavBack) {
        const that = this;
        uni.navigateBack({
          delta: that.backNum,
        });
      } else {
        let isUrl = `/pages/${url}/${url}`;
        console.log(isUrl);
        uni.switchTab({
          url: isUrl,
        });
      }
    },
  },
  created() {
    try {
      const res = uni.getSystemInfoSync();
      let totalTopHeight = 68;
      if (res.model.indexOf('iPhone X') !== -1) {
        totalTopHeight = 88;
      } else if (res.model.indexOf('iPhone') !== -1) {
        totalTopHeight = 64;
      }
      this.statusBarHeight = res.statusBarHeight;
      this.titleBarHeight = totalTopHeight - res.statusBarHeight;
      this.allHeight = totalTopHeight;
    } catch (e) {
      console.log('%c [uni.getSystemInfoSync error]: ', 'color:#1989fa;', e);
      throw e;
    }
  },
};
</script>

<style lang="scss">
.nav-header {
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 900;
  display: flex;
  flex-direction: column;
  background-color: transparent;
  &.bgColor {
    //background-color: #fff;
  }
  .back-hover {
    background-color: #999;
  }
  .top-content {
    width: 100vw;
    height: 100rpx;
    position: relative;
    .goBack {
      position: absolute;
      top: 0;
      left: 0;
      width: 10vw;
      height: 100rpx;
      display: flex;
      align-items: center;
      padding-left: 20rpx;
      box-sizing: border-box;
      image {
        width: 40rpx;
        height: 42rpx;
      }
    }
    .title {
      text-align: center;
      width: 100%;
      height: 100%;
      line-height: 100rpx;
      //font-size: 40rpx;
    }
  }
}
</style>
